import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import PropTypes from 'prop-types';
import { TestCardStyles } from './PlugStyles';
import vialIcon from '../Assets/vial-icon.svg';

const TestCard = ({ testType, testNames }) => (
  <Box sx={TestCardStyles.TestDetailsContainer}>
    <Typography sx={TestCardStyles.TestType}>
      {testType !== undefined ? `Inside - ‘${testType}’` : 'Single Tests'}
    </Typography>
    {testNames?.map(item => (
      <Box sx={TestCardStyles.TestNameIcon} key={item}>
        <img src={vialIcon} alt="profile" width={20} height={20} />
        <Typography sx={TestCardStyles.TestName}>
          {item}
        </Typography>
      </Box>
    ))}
  </Box>
);

TestCard.propTypes = {
  testType: PropTypes.string,
  testNames: PropTypes.arrayOf(PropTypes.string),
};

export default TestCard;
